import { useStore } from 'zustand';
import createRetailMFEStore from './create-store';

// Fallback store used when NikeShop hasn't been initialized yet (e.g., SSR or before MFE loads)
var fallbackStore = createRetailMFEStore();
var useRetailMFEStore = function useRetailMFEStore(select) {
  var _window$NikeShop$__IN, _window$NikeShop;
  var store = (_window$NikeShop$__IN = (_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop['__INTERNAL_USE__']) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.stores) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.retailMFE) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.store) !== null && _window$NikeShop$__IN !== void 0 ? _window$NikeShop$__IN : fallbackStore;
  return useStore(store, select);
};
export default useRetailMFEStore;